import './designerToolbar.less';

import { observer } from 'mobx-react';
import React from 'react';
import b_ from 'b_';

import { DesignerContext } from 'controls/designer/designerStore';

export const b = b_.with('designer-toolbar');

type DesignerToolbarProps = {
	transparent?: boolean;
};

export const DesignerToolbar = observer((props: DesignerToolbarProps) => {
	const store = React.useContext(DesignerContext);
	if (!store.featuresLoaded) return null;

	let hasItemBeforeSeparator = false;

	const items = store.toolbar.items
		.split(' ')
		.map((item, index) => {
			if (item == '|') {
				if (!hasItemBeforeSeparator) {
					return null;
				}
				hasItemBeforeSeparator = false;
				return <li key={index} className={b('item', { type: 'separator' })}></li>;
			}

			const action = store.am.get(item);
			if (action == null || action.visible === false) return null;

			hasItemBeforeSeparator = true;

			if (action.icon) {
				const Icon = action.icon;
				return (
					<li
						key={action.id}
						title={action.tooltip ?? action.title}
						className={b('item', { type: 'icon', toggled: action.toggledWrapper })}
						onClick={() => action.callback()}
					>
						<Icon />
					</li>
				);
			}

			if (action.toolbarEntryRenderer) {
				return <li key={action.id}>{action.toolbarEntryRenderer()}</li>;
			}
		})
		.filter((x) => x);

	return <ul className={b({ transparent: props.transparent })}>{items}</ul>;
});
